import React, { Component } from 'react'
import '../OnlineHelpPage.css'
import TransferList_001 from './img/TransferList_001.png'

export default class TransferList extends Component {
  render() {
    return (
      <div className="main-window">
        <div className="main-window-title">传输列表功能</div>
        <div className="main-window-content">用户下载的内容在传输列表中展示。用户可暂停、取消下载文件</div>
        <img src={TransferList_001} className="main-window-img"></img>
      </div>
    )
  }
}
